/**
 * @function playSound
 * Plays a sound and logs the result to the console
 *
 * @param {HTMLAudioElement} sound The sound to play as an HTMLAudioElement
 * @returns {string}
 */
function playSound(sound: HTMLAudioElement) {
    let soundPromise = sound.play();
    if (soundPromise !== undefined) {
        soundPromise
            .then(() => {
                console.log('played ' + sound.src);
            })
            .catch((error) => {
                console.log('Could not play sound');
            });
    }
}

// Exports
export default playSound;
